import 'src/utils/polyfills';

import invariant from 'invariant';
import * as React from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';

import {bootstrapSentry} from 'src/client/bootstrap-sentry';
import {bootstrapStores} from 'src/client/bootstrap';

import ErrorBoundary from 'src/components/500/boundary';
import ReferralExternalApp from 'src/components/referral-external/app';


const {reduxStore, env} = bootstrapStores();

bootstrapSentry(env);

const appElement = document.getElementById('app');
invariant(appElement, 'Could not render without an #app.');

const [_empty, _referral_external, referralLinkId] =
  window.location.pathname.split('/');
invariant(referralLinkId, 'Could not render without a referralLinkId.');

const urlQueries = new URLSearchParams(window.location.search);
const root =
  env.query.render_mode === 'client'
    ? createRoot(appElement)
    : // @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
      hydrateRoot(appElement);
root?.render(
  <ErrorBoundary>
    <ReferralExternalApp
      referralLinkId={referralLinkId}
      action={urlQueries.get('action') ?? null}
      sourceEmail={urlQueries.get('source_email') ?? null}
      iframe={JSON.parse(urlQueries.get('iframe') || 'false')}
      reduxStore={reduxStore}
    />
  </ErrorBoundary>,
);
